// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogCategoryStaticProps from '../functions/createBlogCategoryStaticProps';
import withEnglishLocale from '../functions/withEnglishLocale';
import BlogCategoryPage from '../components/BlogCategoryPage';


const { getStaticPaths, getStaticProps } = createBlogCategoryStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'blogCategoryEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blog/category', // Array to determine the url - final result is `/${rootPath.join('/')}`
});

export default withEnglishLocale(BlogCategoryPage);
export { getStaticPaths, getStaticProps };
